export default __webpack_public_path__ + "e7804304326d812ccaa213030570114e.png";